/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the various statuses a specimen can have within the laboratory process.
 */
export enum SpecimenLaboratoryStatus {
    RECEIVED = 'received',
    INCONFORM = 'inconform',
    SENT_TO_VALIDATION = 'sentToValidation',
    VALIDATED = 'validated',
    REJECTED = 'rejected',
}
